<template>
  <div
    class="fixed top-0 left-0 z-10 h-screen w-screen bg-nucleus-lightestBlue overflow-auto"
  >
    <LoadingScreen :loaded="loaded" :message="loadingMessage"></LoadingScreen>

    <ErrorBox
      v-if="errorHeading || errorContent"
      :heading="errorHeading"
      :content="errorContent"
      :fixed="errorFixed"
      @closeError="
        errorHeading = '';
        errorContent = '';
      "
    ></ErrorBox>

    <ModalDeleteCheck
      v-if="deleteCheck"
      :text="$t('global.defaults.localUser', 1)"
      @closeModal="deleteCheck = false"
      @deleteMe="deleteUser()"
    ></ModalDeleteCheck>

    <div v-if="loaded">
      <HeaderMini
        :name="$t('global.defaults.localUser', 2)"
        :to="{ name: 'localUsers' }"
        :can-delete="true"
        :can-edit="true"
        :can-resend="user.status === 'FORCE_CHANGE_PASSWORD'"
        :text="$t('global.defaults.localUser', 1)"
        :no-menu="!localAdmin || currentUser.attributes.sub === user.userId"
        @deleteCheck="deleteCheck = true"
        @edit="edit()"
        @resend="resend()"
      ></HeaderMini>
      <HeaderShadow></HeaderShadow>

      <div class="bg-nucleus-white">
        <div class="flex items-center px-4 py-6 border-b">
          <div
            class="text-3xl leading-none p-2 mr-6 flex self-center transition bg-nucleus-primaryBlue text-nucleus-white rounded-full icon-user"
          ></div>
          <div class="text-2xl">
            {{ user.name }}
          </div>
        </div>
        <div class="px-4 pt-6">
          <InfoItem
            :heading="$t('global.defaults.headingAccountStatus')"
            :value="mapUserStatus(user.status)"
          ></InfoItem>
          <InfoItem
            :heading="$t('global.defaults.headingName')"
            :value="user.name"
          ></InfoItem>
          <InfoItem
            :heading="$t('global.defaults.headingMobilePhone')"
            :value="user.phone"
          ></InfoItem>
          <InfoItem
            :heading="$t('global.defaults.headingEmail')"
            :value="user.email"
          ></InfoItem>
          <InfoItem
            v-if="user.createdDate"
            :heading="$t('global.defaults.headingDateCreated')"
            :value="getDate(user.createdDate)"
          ></InfoItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import HeaderMini from "@/components/global/HeaderMini.vue"; // @ is an alias to /src
import HeaderShadow from "@/components/utils/HeaderShadow.vue"; // @ is an alias to /src
import InfoItem from "@/components/utils/InfoItem.vue"; // @ is an alias to /src
import LoadingScreen from "@/components/global/LoadingScreen.vue";
import ModalDeleteCheck from "@/components/global/ModalDeleteCheck.vue";
import { mapAwsUserStatus } from "@/utils/awsMappings";
import ErrorBox from "@/components/utils/ErrorBox.vue";
import { getPrettyDateTime } from "@/utils/prettyDate";
import { getLocalisedError } from "@/utils/apiUtils";

@Options({
  components: {
    HeaderMini,
    HeaderShadow,
    InfoItem,
    LoadingScreen,
    ModalDeleteCheck,
    ErrorBox,
  },
  data() {
    return {
      user: {},
      loaded: false,
      loadingMessage: this.$t("global.defaults.loadingLocal"),
      deleteCheck: false,
      errorHeading: "",
      errorContent: "",
      errorFixed: true,
    };
  },
  computed: {
    localAdmin() {
      return this.$store.getters.getLocalAdmin;
    },
    currentUser() {
      return this.$store.getters.getUserObject;
    },
  },
  beforeMount() {
    this.getUser();
  },
  mounted() {
    document.title =
      this.$t("global.defaults.localUser", 1) +
      " - " +
      this.$t("global.defaults.browserTitle");
  },
  methods: {
    getUser() {
      this.$store
        .dispatch("getLocalUser", this.$route.params.userId)
        .then((response: Record<string, unknown>) => {
          if (response.data) {
            this.loaded = true;
            this.user = response.data;
          }
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error: any) => {
          this.loaded = true;
          this.errorHeading = "";
          this.errorContent = getLocalisedError(error);
        });
    },
    edit() {
      this.$router.push({
        name: "localUsersEdit",
        params: { usedId: this.$route.params.userId },
      });
    },
    resend() {
      this.loaded = false;
      this.$store
        .dispatch("reinviteLocalUser", this.$route.params.userId)
        .then((response: Record<string, unknown>) => {
          if (response) {
            this.getUser();
            console.log("invite local", response);
          }
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error: any) => {
          this.loaded = true;
          this.errorHeading = "";
          this.errorContent = getLocalisedError(error);
        });
    },
    deleteUser() {
      this.loaded = false;
      this.loadingMessage = this.$t("global.defaults.deletingLocal");
      this.$store
        .dispatch("deleteLocalUser", this.$route.params.userId)
        .then((response: Record<string, unknown>) => {
          if (response.data) {
            this.loaded = true;
            this.$store.dispatch("changeUpdate", "localUser");
            this.$router.push({
              name: "localUsers",
            });
          }
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error: any) => {
          this.loaded = true;
          this.errorHeading = "";
          this.errorContent = getLocalisedError(error);
        });
    },
    getDate(date: Date) {
      return getPrettyDateTime(date);
    },
    mapUserStatus(cognitoStatus: string): string {
      return this.$t(mapAwsUserStatus(cognitoStatus));
    },
  },
})
export default class LocalUserDetail extends Vue {}
</script>
